module.exports = __webpack_public_path__ + "static/media/CashPickUp.a89c42a3.svg";